import { useState } from 'react';

type SetValue<T> = (value: T | ((prev: T) => T)) => void;

const useLocalStorage = <T>(key: string, initialValue: T): [T, SetValue<T>] => {
    const [storedValue, setStoredValue] = useState<T>(() => {
        try {
            const item = globalThis.localStorage.getItem(key);
            return item ? (JSON.parse(item) as T) : initialValue;
        } catch (error) {
            console.error(`useLocalStorage: failed to read key "${key}"`, error);
            return initialValue;
        }
    });

    const setValue: SetValue<T> = value => {
        try {
            const valueToStore =
                typeof value === 'function'
                    ? (value as (prev: T) => T)(storedValue)
                    : value;
            setStoredValue(valueToStore);
            globalThis.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            console.error(`useLocalStorage: failed to write key "${key}"`, error);
        }
    };

    return [storedValue, setValue];
};

export default useLocalStorage;
